<ion-header
  class="ion-no-border"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons *ngIf="platform === platformRef.desktop" slot="end">
      <ion-button
        id="close-modal-btn"
        data-cy="close-import-list-error-modal-button"
        (click)="close()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label
      *ngIf="platform !== platformRef.desktop"
      class="bold"
      [class.mobile-title]="platform === platformRef.mobile"
      [class.tablet-title]="platform === platformRef.tablet"
      data-cy="import-list-error-label"
    >
      <span>
        {{ 'i18n.lists.importListModal.errorTitle' | translate }}
      </span>
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div
    class="body-content"
    [class.is-mobile]="platform === platformRef.mobile"
    [class.is-tablet]="platform === platformRef.tablet"
  >
    <p class="title" *ngIf="platform === platformRef.desktop">
      {{ 'i18n.lists.importListModal.errorTitle' | translate }}
    </p>
    <div class="scroll">
      <div *ngFor="let errors of importErrors" class="error-import">
        <p>
          {{ 'i18n.lists.importListModal.errorStart' | translate }}
          {{ errors.rowNumber }}
        </p>
        <p>{{ errors.errorMessage }}</p>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platform !== platformRef.mobile"
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="cancel-import-list-error-modal-button"
        [ngClass]="
          platform !== platformRef?.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="close()"
      >
        {{ 'i18n.common.close' | translate }}
      </ion-button>
      <ion-button
        data-cy="import-list-error-modal-button"
        [ngClass]="
          platform !== platformRef.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="download()"
      >
        {{ 'i18n.common.download' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
